(function(){
  var root=document.getElementById('tlpp'); if(!root) return;
  var colorIdx=+root.getAttribute('data-color-idx')||0;
  var sizeIdx=+root.getAttribute('data-size-idx')||0;
  var variants=[]; try{variants=JSON.parse(document.querySelector('[data-tlpp-variants]').textContent)||[];}catch(e){}

  var sel={color:null,size:null};
  var idInput=root.querySelector('[data-variant-id]');
  var priceEls=[root.querySelector('[data-price]'),root.querySelector('[data-price-inline]')].filter(Boolean);

  function money(cents){return '$'+(cents/100).toFixed(2);}
  function pretty(s){return (s||'').toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase();});}
  function resolve(){
    if(!variants.length) return;
    var v=variants.find(function(x){
      var okC=!colorIdx||x['option'+colorIdx]===sel.color;
      var okS=!sizeIdx||x['option'+sizeIdx]===sel.size;
      return okC&&okS;
    });
    var add=root.querySelector('[data-add]');
    if(v){
      if(idInput) idInput.value=v.id;
      priceEls.forEach(function(e){e.textContent=money(v.price);});
      if(add){ add.disabled=!v.available; add.style.opacity=v.available?'':'.6';
        if(!v.available){ add.childNodes[0].nodeValue='Sold Out '; var pi=add.querySelector('[data-price-inline]'); if(pi)pi.textContent=''; }
        else { add.childNodes[0].nodeValue='Add to Cart · '; }
      }
    }
  }

  // gallery thumbs
  root.querySelectorAll('.tlcp-thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      var i=b.getAttribute('data-i');
      root.querySelectorAll('.tlcp-thumbs button').forEach(function(x){x.classList.toggle('on',x===b);});
      root.querySelectorAll('.tlcp-slide').forEach(function(s){s.classList.toggle('on',s.getAttribute('data-i')===i);});
    });
  });

  // size pills
  root.querySelectorAll('.tlpp-size').forEach(function(p){
    p.addEventListener('click',function(){
      sel.size=p.getAttribute('data-size');
      root.querySelectorAll('.tlpp-size').forEach(function(x){x.classList.toggle('on',x===p);});
      var lab=root.querySelector('[data-size-label]'); if(lab)lab.textContent=sel.size.split('.')[0];
      resolve();
    });
  });

  // color swatches
  root.querySelectorAll('.tlcp-sw').forEach(function(sw){
    sw.addEventListener('click',function(){
      sel.color=sw.getAttribute('data-color');
      root.querySelectorAll('.tlcp-sw').forEach(function(x){x.classList.toggle('on',x===sw);});
      var lab=root.querySelector('[data-color-label]'); if(lab)lab.textContent=pretty(sel.color);
      resolve();
    });
  });

  // qty
  var qi=root.querySelector('[data-qty-input]');
  root.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click',function(){var n=Math.max(1,(parseInt(qi.value,10)||1)+ +b.getAttribute('data-qty'));qi.value=n;});
  });

  // tabs
  root.querySelectorAll('.tlcp-tab').forEach(function(t){
    t.addEventListener('click',function(){
      var p=t.getAttribute('data-tab');
      root.querySelectorAll('.tlcp-tab').forEach(function(x){x.classList.toggle('on',x===t);});
      root.querySelectorAll('.tlcp-panel').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-panel')===p);});
    });
  });

  // init from first-selected pills/swatches
  var s0=root.querySelector('.tlpp-size.on')||root.querySelector('.tlpp-size'); if(s0){s0.classList.add('on');sel.size=s0.getAttribute('data-size');}
  var c0=root.querySelector('.tlcp-sw.on')||root.querySelector('.tlcp-sw'); if(c0){c0.classList.add('on');sel.color=c0.getAttribute('data-color');}
  var cl=root.querySelector('[data-color-label]'); if(cl&&sel.color)cl.textContent=pretty(sel.color);
  var sl=root.querySelector('[data-size-label]'); if(sl&&sel.size)sl.textContent=sel.size.split('.')[0];
  resolve();
})();
